import axios from 'axios';
import { v4 as uuidv4 } from 'uuid';

// ✅ deviceId 생성 및 저장 함수
export function getDeviceId() {
  let deviceId = localStorage.getItem('deviceId');
  if (!deviceId) {
    deviceId = uuidv4();
    localStorage.setItem('deviceId', deviceId);
  }
  return deviceId;
}

// axios instance 생성
const api = axios.create({
  baseURL: `${API_URL}/${API_VERSION}`,
});

// ✅ Access Token 갱신 함수 (refreshToken 활용)
const refreshAccessToken = async () => {
  try {
    const accessToken = localStorage.getItem('accessToken');
    const refreshToken = localStorage.getItem('refreshToken');
    const deviceId = getDeviceId();

    if (!refreshToken) {
      throw new Error('Refresh token not found');
    }

    const response = await axios.post(
      `${GK_API_URL}/${API_VERSION}/auth/app/refresh`,
      {},
      {
        headers: {
          'Authorization': `Bearer ${accessToken}`,
          'x-device-id': deviceId,
          'Content-Type': 'application/json',
        },
      }
    );
    
    // 새로운 토큰들 저장
    const { newAccessToken, newRefreshToken } = response.data;
    localStorage.setItem('accessToken', newAccessToken);
    localStorage.setItem('refreshToken', newRefreshToken);
    localStorage.setItem('userToken', newAccessToken);
    
    return accessToken;
  } catch (error) {
    console.error('Error refreshing access token:', error);
    throw new Error('Failed to refresh access token');
  }
};

// ✅ 요청 인터셉터: Authorization + x-device-id 포함
api.interceptors.request.use(
  async (config) => {
    const accessToken = localStorage.getItem('accessToken');
    const deviceId = getDeviceId();

    // accessToken 있으면 헤더에 추가
    if (accessToken) {
      config.headers.Authorization = `Bearer ${accessToken}`;
      config.headers['Content-Type'] = 'application/json';
      config.headers['x-device-id'] = deviceId;
      return config;
    } else {
      console.log('accessToken 없음');
      window.location.reload();
      return Promise.reject(new Error('User token is missing'));
    }
  },
  (error) => Promise.reject(error)
);

// ✅ 응답 인터셉터: 401 시 토큰 재발급 + 요청 재시도
api.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;
    console.log('에러 발생', error);
    
    // 401 에러 또는 Network Error 처리
    if ((error.response && error.response.status === 401) || 
        (error.code === 'ERR_NETWORK' && !originalRequest._retry)) {
      
      if (!originalRequest._retry) {
        originalRequest._retry = true;
        console.log('토큰 갱신 시도');
        
        // eslint 때문에 살려 두겠습니다 - 덕
        try {
          const newToken = await refreshAccessToken();
          const deviceId = getDeviceId();

          originalRequest.headers.Authorization = `Bearer ${newToken}`;
          originalRequest.headers['x-device-id'] = deviceId;

          return api(originalRequest);
        } catch (refreshError) {
          console.log('토큰 갱신 실패', refreshError);
          // 모든 토큰 삭제
          localStorage.removeItem('userToken');
          localStorage.removeItem('accessToken');
          localStorage.removeItem('refreshToken');
          //window.location.reload();
          return Promise.reject(refreshError);
        }
      }
    }

    return Promise.reject(error);
  }
);

export default api;